import { Routes } from '@angular/router';
import { authenticatedGuard } from '@core/guards/authenticated.guard';
import { AppShellComponent } from './layout';
import { environment } from '../environments/environment';
import {
  ActiveBankAccountsState,
  PaymentGatewaysState,
} from '@shared/services';
import { GiftcardStateService } from './domains/giftcard/data/giftcard.state';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./domains/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  ...(environment.devTools
    ? [
        {
          path: 'storybook',
          loadChildren: () =>
            import('./dev-tools/story-book/story-book.routes').then(
              (m) => m.storiesRoutes,
            ),
        },
      ]
    : []),
  {
    path: '',
    component: AppShellComponent,
    canActivate: [authenticatedGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./domains/dashboard/dashboard.routes').then(
            (m) => m.DASHBOARD_ROUTES,
          ),
      },
      {
        path: 'panel',
        loadChildren: () =>
          import('./domains/panel/panel.routes').then((m) => m.PANEL_ROUTES),
      },
      {
        path: 'categories',
        loadChildren: () =>
          import('./domains/categories/categories.routes').then(
            (m) => m.CATEGORIES_ROUTES,
          ),
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./domains/orders/orders.routes').then((m) => m.ORDERS_ROUTES),
      },
      {
        path: 'basket',
        providers: [
          GiftcardStateService,
          PaymentGatewaysState,
          ActiveBankAccountsState,
        ],
        loadComponent: () =>
          import('./domains/giftcard/pages/basket-page/basket-page').then(
            (m) => m.BasketPage,
          ),
      },
    ],
  },
  {
    path: '**',
    loadChildren: () =>
      import('./domains/not-found/not-found-page').then(
        (m) => m.NotFoundPageComponent,
      ),
  },
];
